import { useContext } from 'react';
import HistoryPageContext, { HistoryPageContextContent } from '../HistoryPageContext';

export default ():
  HistoryPageContextContent => useContext(HistoryPageContext);
